<template>
	<div>
		<v-tabs
			v-model:model-value="tab"
			bg-color="transparent"
		>
			<v-tab
				:value="0"
			>
				<div style="font-size: 16px">
					1. <translate>Your complaint</translate>
				</div>
			</v-tab>
			<v-tab
				:disabled="tab < 1"
				:value="1"
			>
				<div style="font-size: 16px">
					2. <translate>Your details</translate>
				</div>
			</v-tab>
			<v-tab
				:disabled="tab < 2"
				:value="2"
			>
				<div style="font-size: 16px">
					3. <translate>Check</translate>
				</div>
			</v-tab>
		</v-tabs>
		<v-window v-model:model-value="tab">
			<v-window-item>
				<v-card>
					<v-card-text>
						<v-row>
							<v-col>
								<h2>
									<translate>File complaint</translate>
								</h2>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<span>
									<translate>
										We try our hardest to offer our customers a good service. Of course, it might turn out that
										you're not completely satisfied with our service provision and have a complaint. We take complaints
										very seriously, which is why we use your complaint to improve our service.
									</translate>
								</span>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<h2>
									<translate>Processing time</translate>
								</h2>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<span>
									<translate>
										We always strive to resolve complaints as soon as possible. We will send a reply to your complaint
										within 15 business days. If we need more time to process your complaint, we will let you know as
										soon as possible and we will let you know when we will come to a decision. In the meantime, we will
										keep you updated on the status of your complaint via email.
									</translate>
								</span>
							</v-col>
						</v-row>

						<v-row>
							<v-col>
								<h2><translate>Complaint form</translate></h2>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<h4><strong><translate>Policy number</translate></strong></h4>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col>
								<v-radio-group
									v-model:model-value="selectedPolicy"
									:error-messages="errors.selectedPolicy"
								>
									<v-radio
										v-for="policy in policies"
										:key="createPolicyLabel(policy)"
										:value="policy"
										color="primary"
										:label="createPolicyLabel(policy)"
									/>
								</v-radio-group>
							</v-col>
						</v-row>

						<v-row>
							<v-col>
								<h4><strong><translate>What is your complaint about?</translate></strong></h4>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col>
								<v-radio-group
									v-model="complaintReason"
									:error-messages="errors.complaintReason"
								>
									<v-radio
										color="primary"
										:label="$gettext(rejectionClaimReason)"
										:value="rejectionClaimReason"
									/>
									<div
										v-if="complaintReason === rejectionClaimReason"
										style="margin-left: 2em; font-size: 14px"
									>
										<translate>
											If you disagree with the rejection of your claim, you can use the complaints procedure.
											Click
										</translate> <a :href="objectionsRoute"><translate>here</translate></a> <translate>
											to go to the objection form.
										</translate>
									</div>
									<v-radio
										color="primary"
										:label="$gettext(websiteReason)"
										:value="websiteReason"
									/>
									<v-radio
										color="primary"
										:label="$gettext(processingReason)"
										:value="processingReason"
									/>
									<v-radio
										color="primary"
										:label="$gettext(policyReason)"
										:value="policyReason"
									/>
									<v-radio
										color="primary"
										:label="$gettext(employeeReason)"
										:value="employeeReason"
									/>
									<div
										v-if="complaintReason === employeeReason"
										style="margin-left: 2em"
									>
										<strong><translate>Which employee does this concern?</translate></strong>
										<v-radio-group
											v-if="complaintReason === employeeReason"
											v-model="employeeType"
											:error-messages="errors.employeeType"
										>
											<v-radio
												color="primary"
												:label="$gettext(storeEmployee)"
												:value="storeEmployee"
											/>
											<div v-if="employeeType === storeEmployee">
												<strong><translate>Do you know the name of the employee that you want to file a complaint about? If so, enter the name below</translate></strong>
												<v-textarea
													v-model="employeeName"
													:label="$gettext('Enter the name of the employee here')"
													auto-grow
													color="primary"
													rows="1"
													variant="outlined"
												/>
												<strong><translate>Which store?</translate></strong>
												<v-textarea
													v-model="storeName"
													:error-messages="errors.storeName"
													:label="$gettext('Enter the name of the store here (e.g. Store Amsterdam)')"
													auto-grow
													color="primary"
													rows="1"
													variant="outlined"
												/>
											</div>

											<v-radio
												color="primary"
												:label="$gettext(customerServiceEmployee)"
												:value="customerServiceEmployee"
											/>
											<v-textarea
												v-if="employeeType === customerServiceEmployee"
												v-model="employeeName"
												:label="$gettext('Enter the name of the employee here')"
												auto-grow
												color="primary"
												rows="1"
												variant="outlined"
											/>
										</v-radio-group>
									</div>

									<v-radio
										color="primary"
										:label="$gettext(invoiceReason)"
										:value="invoiceReason"
									/>
									<div
										v-if="complaintReason === invoiceReason"
										style="margin-left: 2em"
									>
										<strong><translate>What kind of costs?</translate></strong>
										<v-radio-group
											v-model="invoiceCostType"
											:error-messages="errors.invoiceCostType"
										>
											<v-radio
												color="primary"
												:label="$gettext('Deductible')"
												value="deductible"
											/>
											<v-radio
												color="primary"
												:label="$gettext('Premium')"
												value="premium"
											/>
											<v-radio
												color="primary"
												:label="$gettext('Other costs')"
												value="other"
											/>
										</v-radio-group>
									</div>

									<v-radio
										color="primary"
										:label="$gettext(otherReason)"
										:value="otherReason"
									/>
									<v-textarea
										v-if="complaintReason === otherReason"
										v-model="otherReasonText"
										:error-messages="errors.otherReason"
										:label="$gettext('Enter your complaint here')"
										auto-grow
										color="primary"
										rows="1"
										variant="outlined"
									/>
								</v-radio-group>
							</v-col>
						</v-row>

						<v-row>
							<v-col>
								<h4><strong><translate>Give a clear and complete description of the situation that led to your complaint below.</translate></strong></h4>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col>
								<v-textarea
									v-model="complaintDescription"
									auto-grow
									color="primary"
									:label="$gettext('Enter your description here')"
									:error-messages="errors.complaintDescription"
									rows="6"
									variant="outlined"
								/>
							</v-col>
						</v-row>

						<v-row>
							<v-col>
								<h4><strong><translate>Were you offered a solution for your complaint?</translate></strong></h4>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col>
								<v-radio-group
									v-model="complaintOfferedSolution"
									:error-messages="errors.complaintOfferedSolution"
								>
									<v-radio
										color="primary"
										:label="$gettext(offeredSolution)"
										:value="offeredSolution"
									/>
									<v-textarea
										v-if="complaintOfferedSolution === offeredSolution"
										v-model="offeredSolutionText"
										auto-grow
										color="primary"
										:label="$gettext('Enter the offered solution here')"
										:error-messages="errors.offeredSolutionText"
										rows="6"
										variant="outlined"
									/>

									<v-radio
										color="primary"
										:label="$gettext(noOfferedSolution)"
										:value="noOfferedSolution"
									/>
								</v-radio-group>
							</v-col>
						</v-row>

						<v-row>
							<v-col>
								<h4><strong><translate>What solution do you want for your complaint?</translate></strong></h4>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col>
								<v-textarea
									v-model="complaintWantedSolution"
									auto-grow
									color="primary"
									:label="$gettext('Enter the solution you want here')"
									:error-messages="errors.complaintWantedSolution"
									rows="6"
									variant="outlined"
								/>
							</v-col>
						</v-row>

						<v-row>
							<v-col>
								<h4><strong><translate>Include attachment (optional)</translate></strong></h4>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col>
								<file-input
									v-model="attachment"
									show-size
									variant="outlined"
									color="primary"
									accept="image/*,.pdf"
									:label="$gettext('Upload an image or pdf file')"
								/>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-window-item>

			<v-window-item>
				<my-profile
					:user-business="userBusiness"
					:user-personal="userPersonal"
					:user-address="userAddress"
					:user-email="userEmail"
					:user-telephone-numbers="userTelephoneNumbers"
					:user-bank="userBank"
					:user-newsletter="userNewsletter"
					:new-window="true"
				/>
			</v-window-item>

			<v-window-item>
				<v-card variant="flat">
					<v-card-text>
						<v-row>
							<v-col>
								<h2>
									<translate>Your complaint</translate>
								</h2>
							</v-col>
						</v-row>

						<v-row no-gutters>
							<v-col md6>
								<strong><translate>Policy number</translate>:</strong>
							</v-col>
							<v-col md6>
								{{ getSelectedPolicyNumber }}
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col md6>
								<strong><translate>Insured device</translate>:</strong>
							</v-col>
							<v-col md6>
								{{ getSelectedPhone }}
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col md6>
								<strong><translate>I have a complaint about</translate>:</strong>
							</v-col>
							<v-col md6>
								{{ $gettext(complaintReason) }}
								<div v-if="complaintReason === employeeReason">
									{{ $gettext(employeeType) }}
									<br>
									{{ employeeName }}
									<div v-if="employeeType === storeEmployee">
										{{ storeName }}
									</div>
								</div>
								<div v-if="complaintReason === invoiceReason">
									{{ invoiceCostType }}
								</div>
								<div v-if="complaintReason === otherReason">
									{{ otherReasonText }}
								</div>
							</v-col>
						</v-row>

						<v-row no-gutters>
							<v-col md6>
								<strong><translate>Explanation complaint</translate>:</strong>
							</v-col>
							<v-col md6>
								{{ complaintDescription }}
							</v-col>
						</v-row>

						<v-row no-gutters>
							<v-col md6>
								<strong><translate>Offered solution</translate>:</strong>
							</v-col>
							<v-col md6>
								<translate>{{ $gettext(complaintOfferedSolution) }}</translate>
								<div v-if="complaintOfferedSolution === offeredSolution">
									{{ offeredSolutionText }}
								</div>
							</v-col>
						</v-row>

						<v-row no-gutters>
							<v-col md6>
								<strong><translate>Desired solution</translate>:</strong>
							</v-col>
							<v-col md6>
								{{ complaintWantedSolution }}
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col md6>
								<strong><translate>Attachment (optional)</translate></strong>
							</v-col>
							<v-col md6>
								<div v-if="attachment !== null">
									{{ getAttachmentName }}
								</div>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-window-item>
		</v-window>
		<v-row>
			<v-col cols="auto">
				<v-btn
					v-if="tab !== 0"
					variant="text"
					color="primary"
					@click="() => { if (tab > 0) --tab; }"
				>
					<translate>Previous</translate>
				</v-btn>
			</v-col>
			<v-spacer />
			<v-col cols="auto">
				<v-btn
					v-if="tab === 2"
					color="primary"
					@click="submitComplaintForm()"
				>
					<translate key="Send">
						Send
					</translate> <!-- key doesn't do anything but is necessary for an edge case bug with <translate -->
				</v-btn>
				<v-btn
					v-else
					color="primary"
					@click="nextTab"
				>
					<translate key="Next">
						Next
					</translate>
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>

import axios from 'axios';
import {
	inform,
} from 'laravel-front-library';
import RouteTranslator from '../../mixins/RouteTranslator';

export default {
	name: 'ComplaintForm',
	mixins: [RouteTranslator, ],
	props: {
		policies: {
			type: Array,
			required: false,
			/**
			 * @returns {Array}
			 */
			default: function () {
				return [];
			},
		},

		/* The following props are for the user detail page */
		userBusiness: {
			type: Object,
			required: true,
		},
		userPersonal: {
			type: Object,
			required: true,
		},
		userAddress: {
			type: Object,
			required: false,
			/**
			 * @returns {object}
			 */
			default: function () {
				return {
				};
			},
		},
		userEmail: {
			type: String,
			required: true,
		},
		userTelephoneNumbers: {
			type: Array,
			required: true,
		},
		userBank: {
			type: Array,
			required: true,
		},
		userNewsletter: {
			type: Number,
			required: true,
		},
	},

	data () {
		return {
			tab: 0,
			complaintReason: null,
			employeeType: null,
			invoiceCostType: null,
			complaintOfferedSolution: null,
			complaintWantedSolution: '',
			employeeName: '',
			storeName: '',
			otherReasonText: '',
			complaintDescription: '',
			offeredSolutionText: '',
			attachment: null,
			selectedPolicy: null,

			objectionsRoute: '/dashboard/objections',
			submitRoute: '/dashboard/complaints/submitcomplaint',
			dashboardRoute: '/dashboard',

			rejectionClaimReason: 'A rejection of a claim',
			websiteReason: 'The website',
			processingReason: 'The processing time of my claim',
			policyReason: 'The policy of Tulip Assist',
			employeeReason: 'The behaviour of an employee',
			storeEmployee: 'Store employee',
			customerServiceEmployee: 'Customer service employee',
			invoiceReason: 'An invoice',
			otherReason: 'Other reason',
			offeredSolution: 'Yes',
			noOfferedSolution: 'No',

			errors: this.getInitialErrors,
		};
	},

	computed: {
		/**
		 * @returns {string}
		 */
		getSelectedPhone: function () {
			return (this.selectedPolicy !== null && ('phoneName' in this.selectedPolicy)) ? this.selectedPolicy.phoneName : '';
		},

		/**
		 * @returns {string}
		 */
		getSelectedPolicyNumber: function () {
			return (this.selectedPolicy !== null && ('policyNumber' in this.selectedPolicy)) ? this.selectedPolicy.policyNumber : '';
		},

		/**
		 * @returns {string}
		 */
		getAttachmentName: function () {
			return this.attachment !== null ? this.attachment[0].name : '';
		},
	},

	created () {
		this.translateRoute(this.objectionsRoute).then((translatedPath) => {
			this.objectionsRoute = translatedPath;
		});
		this.translateRoute(this.submitRoute).then((translatedPath) => {
			this.submitRoute = translatedPath;
		});
		this.translateRoute(this.dashboardRoute).then((translatedPath) => {
			this.dashboardRoute = translatedPath;
		});
	},

	methods: {
		/**
		 * Initial error object
		 *
		 * @returns {object}
		 */
		getInitialErrors () {
			return {
				selectedPolicy: '',
				rejectionClaim: '',
				complaintReason: '',
				employeeReason: '',
				storeName: '',
				invoiceCostType: '',
				otherReason: '',
				complaintDescription: '',
				offeredSolutionText: '',
				complaintWantedSolution: '',

			};
		},


		/**
		 * @param {object} policy
		 * @returns {string}
		 */
		createPolicyLabel (policy) {
			if(policy.phoneName) {
				return policy.policyNumber.concat(' - ', policy.phoneName);
			}
			return policy.policyNumber;
		},

		/**
		 * Attempts to move to the next tab, sets an error if not able
		 *
		 * @returns {void}
		 */
		nextTab () {
			if (this.tab < 2) {
				if (this.tab === 0) {

					this.errors = this.getInitialErrors();
					if(this.selectedPolicy === null) {
						this.errors.selectedPolicy = 'Please select a policy';
					}
					if (this.complaintReason === null) {
						this.errors.complaintReason = 'Please check one of the available options';
					} else if (this.complaintReason === this.rejectionClaimReason) {
						this.errors.complaintReason = 'Please follow the complaints procedure instead';
					}
					if (this.complaintReason === this.employeeReason) {
						if (this.employeeType === null) {
							this.errors.employeeType = 'Please select which employee this concerns';
						} else if (this.employeeType === this.storeEmployee && this.storeName === '') {
							this.errors.storeName = 'Please fill in the name of the store you visited';
						}
					}

					if (this.complaintReason === this.invoiceReason && this.invoiceCostType === null) {
						this.errors.invoiceCostType = 'Please select what kind of cost';
					}
					if(this.complaintReason === this.otherReason && this.otherReasonText === '') {
						this.errors.otherReason = 'Please fill in your complaint';
					}
					if(this.complaintDescription === '') {
						this.errors.complaintDescription = 'Please fill in the description of your complaint';
					}

					if (this.complaintOfferedSolution === null) {
						this.errors.complaintOfferedSolution = 'Please select whether or not you\'ve been offered a solution';
					} else if (this.complaintOfferedSolution === this.offeredSolution && this.offeredSolutionText === '') {
						this.errors.offeredSolutionText = 'Please fill in the offered solution';
					}

					if (this.complaintWantedSolution === '') {
						this.errors.complaintWantedSolution = 'Please fill in your desired solution';
					}

					for (const value in this.errors) {
						if(Object.hasOwnProperty.call(this.errors, value)) {
							if (this.errors[value] !== '') {
								return;
							}
						}
					}
				}
				this.tab++;
			}
		},

		/**
		 * Submit the complaint form data to our backend
		 *
		 * @returns {void}
		 */
		submitComplaintForm () {
			/* eslint-disable*/
			const dataToSend = JSON.stringify({
				policy_number: this.getSelectedPolicyNumber,
				policy_device: this.getSelectedPhone,
				complaint_reason: this.getCompleteReason(),
				complaint_description: this.complaintDescription,
				complaint_offered_solution: this.offeredSolutionText,
				complaint_wanted_solution: this.complaintWantedSolution,
				attachment_name: this.getAttachmentName,
			});
			const formData = new FormData();

			formData.set('formData', dataToSend);
			if(this.attachment !== null) {
				formData.append('attachment', this.attachment[0]);
			}

			axios({
				url: this.submitRoute,
				method: 'POST',
				dataType: 'json',
				data: formData,
				config: {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				},
			}).then(() => {
				inform(this.$gettext('Complaints submitted'));
				window.location.href = this.dashboardRoute;
			})
				.catch((error) => {
					inform(this.$gettext('Submission failure. Please contact klachten@tulipassist.nl directly'));
					window.captureException(error);
				});
		},

		/**
		 * Sort the reason data into an array and return it
		 *
		 * @return {Array}
		 */
		getCompleteReason () {
			const completeReason = [];

			completeReason.push(this.$gettext(this.complaintReason));
			if (this.complaintReason === this.employeeReason) {
				completeReason.push(this.$gettext(this.employeeType));
				if(this.employeeName !== '') {
					completeReason.push(this.$gettext(this.employeeName));
				}
				if(this.employeeType === this.storeEmployee) {
					completeReason.push(this.$gettext(this.storeName));
				}
			}
			if (this.complaintReason === this.invoiceReason) {
				completeReason.push(this.$gettext(this.invoiceCostType));
			}
			if (this.complaintReason === this.otherReason) {
				completeReason.push(this.$gettext(this.otherReasonText));
			}
			return completeReason;
		},
	},
};
</script>

<style scoped>
	*{text-transform: none !important;}
	::v-deep .v-input__control {
		width: 100%
	}
    ::v-deep .theme--light.v-tabs-items {
        background-color: transparent;
    }
</style>
